if ($('.type-detail').length) {
    var textFriends = '#kamaradi';

    if ($('table.detail-parameters tbody tr th').text().trim().includes(textFriends)) {

        var apiUrl = "https://friends.shopcode.cz/new/api-products.php";
        var section = "timberstore";
        var codes = [];

        $('table.detail-parameters tbody tr').each(function () {
            var headerText = $(this).find('th span.row-header-label').text().trim();
            var friendName = $(this).find('td').text().trim();

            if (headerText.includes(textFriends)) {
                $(this).closest('tr').hide();
                codes.push(friendName);
            }
        });

        if (codes.length === 0) {
            console.warn("Žádné hodnoty " + textFriends + " nebyly nalezeny.");
        } else {

            $.ajax({
                url: apiUrl,
                type: "GET",
                data: {
                    section: section,
                    codes: getShoptetDataLayer('product').codes[0].code
                },
                dataType: "json",

                success: function (response) {
                    console.log(response);

                    var productCode = String(getShoptetDataLayer('product').codes[0].code || '').trim();

                    if (!response || !response.result || !Array.isArray(response.result)) {
                        console.warn("Neplatná odpověď API:", response);
                        return;
                    }

                    var itemData = response.result.find(function (item) {
                        return String(item.code || '').trim() === productCode;
                    });

                    if (!itemData) {
                        console.warn("Nenalezen objekt pro CODE:", productCode);
                        return;
                    }

                    var alternatives = itemData.alternatives || [];

                    if (!alternatives.length) {
                        console.warn("Nenalezeni kamarádi produktu.");
                        return;
                    }

                    $('.friendsSection').remove();

                    $(".p-info-wrapper .detail-parameters").after(`
                        <div class="friendsSection">
                            <div class="h3">Všetky varianty:</div>
                            <div class="inner"></div>
                        </div>
                    `);

                    alternatives = alternatives
                        .filter(function (item) {
                            return !item.VISIBILITY || String(item.VISIBILITY).toLowerCase() !== "hidden";
                        })
                        .sort(compareByVariantName);

                    alternatives.forEach(function (itemProduct) {
                        var name = String(itemProduct.NAME || '').trim();
                        var nameEscaped = escapeHtmlAttr(name);

                        var url = String(itemProduct.URL || '').trim();

                        var currentPath = document.location.pathname.replace(/\/$/, '');
                        var itemPath = url.replace(/^https?:\/\/[^\/]+/, '').replace(/\/$/, '');

                        var customClass = currentPath === itemPath ? 'active' : '';

                        var imageUrl = itemProduct.IMAGE && String(itemProduct.IMAGE).trim()
                            ? itemProduct.IMAGE.replace('/orig/', '/detail/')
                            : 'https://cdn.myshoptet.com/prj/dist/master/cms/img/common/missing_images/big.png';

                        var kamaradiHodnota = itemProduct.KAMARADI_HODNOTY;
                        var kamaradiHodnotaEscaped = escapeHtmlAttr(kamaradiHodnota);

                        var imageHtml = url
                            ? `<a href="${url}"><img src="${imageUrl}" alt="${nameEscaped}"></a>`
                            : `<span><img src="${imageUrl}" alt="${nameEscaped}"></span>`;

                        var nameHtml = url
                            ? `<a href="${url}">${kamaradiHodnotaEscaped}</a>`
                            : `<span>${kamaradiHodnotaEscaped}</span>`;

                        var detailHtml = `
                            <div class="friend ${customClass} show-tooltip" data-title="${nameEscaped}" data-original-title="${nameEscaped}">
                                <div class="p">
                                    <div class="image">
                                        ${imageHtml}
                                    </div>

                                    <div class="name">
                                        ${nameHtml}
                                    </div>
                                </div>
                            </div>
                        `;

                        $(".friendsSection .inner").append(detailHtml);
                    });

                    initFriendsShowMore();
                },

                error: function (xhr, status, error) {
                    console.error("Chyba při volání API:", error);
                }

            }).done(function () {
                if (typeof initTooltips === 'function') {
                    initTooltips();
                }
            });
        }

        function compareByVariantName(a, b) {
            var aVal = getTextAfterLastDash(a.NAME || '').toLowerCase().trim();
            var bVal = getTextAfterLastDash(b.NAME || '').toLowerCase().trim();

            return aVal.localeCompare(bVal, 'sk', {
                numeric: true,
                sensitivity: 'base'
            });
        }

        function initFriendsShowMore() {
            var $inner = $(".friendsSection .inner");
            var $friends = $inner.find(".friend");
            var limit = 8;

            if ($friends.length <= limit) {
                return;
            }

            var $active = $friends.filter(".active");

            if ($active.length) {
                $inner.prepend($active);
            }

            var $all = $inner.find(".friend");

            $all.each(function (index) {
                if (index >= limit) {
                    $(this).hide();
                }
            });

            var $btn = $(`
                <button class="btn btn-primary friendsShowMore" type="button">
                    Zobraziť viac
                </button>
            `);

            $btn.on("click", function () {
                $all.show();
                $(this).remove();

                if (typeof initTooltips === 'function') {
                    initTooltips();
                }
            });

            $inner.append($btn);
        }

        function escapeHtmlAttr(text) {
            return String(text || '')
                .replace(/&/g, "&amp;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;");
        }

        function getTextAfterLastDash(value) {
            value = String(value || '').trim();

            if (!value.includes('-')) {
                return value;
            }

            return value.split('-').pop().trim();
        }
    }
}